import type { GetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions200 } from '@fukuri-admins/apis/client/gen/model';
import type { CustomFieldDefinition, TargetModel } from '~/types/resources/CustomFieldDefinition';

const isTargetModel = (value: string): value is TargetModel =>
  value === 'client' || value === 'user_profile';

type IConvertToCustomFieldDefinitions = (
  data: GetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions200
) => CustomFieldDefinition[];

/**
 * カスタムフィールド定義APIレスポンスをアプリ内型に変換する
 */
export const convertToCustomFieldDefinitions: IConvertToCustomFieldDefinitions = data =>
  data.custom_field_definitions.map(def => ({
    id: def.id,
    label: def.label,
    input_type: def.input_type,
    value_type: def.value_type,
    target_model: isTargetModel(def.target_model) ? def.target_model : 'client',
    options: def.options
      ? Object.fromEntries(Object.entries(def.options).map(([k, v]) => [k, String(v ?? '')]))
      : undefined,
  }));
